import api from "./api";

/* ── NOTIFICATION LIST (paginated, filterable) ── */
export const getNotifications = async (params = {}) => {
  const response = await api.get("notifications/", { params });
  return response.data;
};

/* ── GET SINGLE NOTIFICATION ── */
export const getNotification = async (id) => {
  const response = await api.get(`notifications/${id}/`);
  return response.data;
};

/* ── CREATE NOTIFICATION (admin/HR announcement) ── */
export const createNotification = async (data) => {
  const response = await api.post("notifications/", data);
  return response.data;
};

/* ── DELETE NOTIFICATION ── */
export const deleteNotification = async (id) => {
  await api.delete(`notifications/${id}/`);
};

/* ── MARK SINGLE AS READ ── */
export const markNotificationRead = async (id) => {
  const response = await api.post(`notifications/${id}/mark-read/`);
  return response.data;
};

/* ── MARK ALL AS READ ── */
export const markAllNotificationsRead = async () => {
  const response = await api.post("notifications/mark-all-read/");
  return response.data;
};

/* ── UNREAD COUNT (for badge) ── */
export const getUnreadCount = async () => {
  const response = await api.get("notifications/unread-count/");
  return response.data;
};
